import Service, { getCallApiFunction } from '../../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

class FetchUserAuthRegisterApi extends Service {
  constructor(params: any) {
    super()
    this.name = 'FETCH_USER_AUTH_REGISTER'

    this.config = {
      url: `/v1/user-auth/register`,
      method: 'POST',
      data: { ...params },
    }
  }
}

export const fetchUserAuthRegister = (params: any) => getCallApiFunction(new FetchUserAuthRegisterApi(params))
